export const COMPANY = 'company'
export const COMPANY_MEMBER = 'company_member'
export const COMPANY_MANAGER = 'company_manager'
export const SOLE_PROPRIETOR = 'sole_proprietor'
export const PROPERTY_DATA_COLLECTOR = 'property_data_collector'
export const AMC = 'amc'
export const USER = 'user'
export const APPRAISER = 'appraiser'
export const MANAGER = 'manager'

export const STAFF_APPRAISER = 'staff'
export const CONTRACT_APPRAISER = 'contract'

export const IN_PROGRESS = 'in_progress'
export const COMPLETE = 'complete'

// Items required for different signup flows, to
// display previous to account setup
export const STATE_CREDENTIALS = 'StateCredentials'
export const EO_INSURANCE = 'EOInsurance'
export const W_9 = 'W9'
export const BANK_INFO = 'BankInfo'
export const ADDRESS_COVERAGE = 'AddressAndCoverage'

// Account setup wizard step keys
export const CREDENTIALS = 'Credentials'
export const COMPANY_OR_COVERAGE = 'CompanyOrCoverage'
export const TAX_AND_INSURANCE = 'TaxAndInsurance'
export const PAYMENT = 'Payment'
export const PROPERTY_DATA_COLLECTOR_SETUP = 'PropertyDataCollectorSetup'

// TaxAndInsurance constants
export const UPLOAD = 'upload'
export const ONLINE = 'online'
export const OTHER = 'other'
export const LLC = 'llc'

export const TAX_CLASSIFICATION_OPTIONS = [
  { name: 'sp', label: 'Individual/sole proprietor or single-member LLC' },
  { name: 'ccorp', label: 'C Corporation' },
  { name: 'scorp', label: 'S Corporation' },
  { name: 'partnership', label: 'Partnership' },
  { name: 'trust', label: 'Trust/estate' },
  { name: LLC, label: 'Limited liability company' },
  { name: OTHER, label: 'Other' },
]

export const TAX_NUMBER_OPTIONS = [
  { name: 'ssn', label: 'I can provide my social security number' },
  { name: 'ein', label: 'I can provide my employer identification number' },
]

export const LLC_CLASSIFICATION_OPTIONS = [
  { name: 'C', label: 'C Corporation' },
  { name: 'S', label: 'S Corporation' },
  { name: 'P', label: 'Partnership' },
]
export const USER_INFORMATION_UPDATE = 'information_update'
export const USER_SECURE_UPDATE = 'secure_update'

export const USER_TYPE_LABEL_MAP = {
  [COMPANY]: 'Appraisal Company',
  [SOLE_PROPRIETOR]: 'Individual Appraiser',
  [PROPERTY_DATA_COLLECTOR]: 'Property Data Collector',
}

export const CARD = 'Card'
export const BANK_ACCOUNT = 'Bank Account'

export const COMPANY_COVERAGE_STATE_LIMIT = 5

// Phone types
export const MOBILE = 'mobile'
export const HOME = 'home'
export const WORK = 'work'
export const PHONE_TYPES_MAP = [
  { name: 'Mobile', value: MOBILE },
  { name: 'Home', value: HOME },
  { name: 'Work', value: WORK },
]
